import { useState, useEffect, useContext } from "react"
import { DataGrid } from "@mui/x-data-grid"
import axios from "axios"
import { Link as RouterLink, useNavigate } from "react-router-dom"
import TextField from "@mui/material/TextField"
import Box from "@mui/material/Box"
import Switch from "@mui/material/Switch"
import Button from "@mui/material/Button"
import MenuItem from "@mui/material/MenuItem"
import Select from "@mui/material/Select"
import Alert from "@mui/material/Alert"
import Snackbar from "@mui/material/Snackbar"
import AuthContext from "../../AuthContext"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"
import { API_URL } from "../../config"
export default function AdminCustomerPanel({
    className,
    title,
    content,
    ...props
}) {
    const [pageSize, setPageSize] = useState(10)
    const { token } = useContext(AuthContext)
    const [rows, setRows] = useState([])
    const [filter, setFilter] = useState("Pending")
    const [showSnackbar, setShowSnackbar] = useState(false)
    const [snackbarMessage, setSnackbarMessage] = useState(false)
    const [s, setS] = useState(1)
    // for changing email
    const [account, setAccount] = useState("") 
    const [email, setEmail] = useState("") 
    const reload = () => {
        setS(s * -1)
    }

    const getFields = (params) => {
        const api = params.api

        const fields = api
        .getAllColumns()
        .map((c) => c.field)
        .filter((c) => c !== "__check__" && !!c)
        const thisRow = {}

        fields.forEach((f) => {
            thisRow[f] = params.row[f]
        })

        return thisRow
    }
    const updatedField = (field, previousField) => {
        if (previousField != null && previousField != field) {
            return (
                <>
                    {field}
                    <br />
                    <s style={{ color: "grey" }}>{previousField}</s>
                </>
            )
        } else {
            return field
        }
    }
    const setCompleted = (id, completed) => {
        setRows((prevRows) =>
            prevRows.map((row) => (row.id === id ? { ...row, completed } : row))
        )
    }

    const handleFilterChange = (event) => {
        setFilter(event.target.value)
    }

    // useEffect(() => {
    //   if (token) {
    //     let url = `${API_URL}/customer/requests`
    //     axios
    //       .get(url, {
    //         headers: {
    //           Authorization: `Bearer ${token}`,
    //         },
    //       })
    //       .then((response) => {
    //         response.data.forEach((item, i) => {
    //           item.id = i + 1
    //         })
    //         setRows(response.data)
    //       })
    //       .catch((error) => {
    //         console.error("Error fetching account requests:", error)
    //       })
    //   } else {
    //     console.error("No token available")
    //   }
    // }, [token, s])

    useEffect(() => {
        if (token) {
            let url = `${API_URL}/customer/blacklist`
            axios
                .get(url, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                })
                .then((response) => {
                    response.data.forEach((item, i) => {
                        item.id = i + 1
                    })
                    setRows(response.data)
                })
                .catch((error) => {
                    console.error("Error fetching blacklist:", error)
                })
        } else {
            console.error("No token available")
        }
    }, [token, s])

  const filteredRows = rows.filter((row) => row.acc_code.toLowerCase().includes(account));


    return (
        <div {...props} id="blacklist">
            <Box
                sx={{
                    marginBottom: 2,
                    display: "flex",
                    gap: 2,
                    justifyContent: "space-between",
                }}
            >
                <p>Credits/Blacklist</p>
            </Box>
      <Box sx={{ marginBottom: 2, display: "flex", gap: 2 }}>
        <TextField
          label="Search"
          variant="outlined"
          value={account}
          onChange={(e) => setAccount(e.target.value)}
          fullWidth
        />
        </Box>
            {/* <Box sx={{ marginBottom: 2, display: "flex", gap: 2 }}> */}
            {/*   <Select value={filter} onChange={handleFilterChange} displayEmpty> */}
            {/*     <MenuItem value="Pending"> */}
            {/*       <em>Pending</em> */}
            {/*     </MenuItem> */}
            {/*     <MenuItem value="Completed"> */}
            {/*       <em>Completed</em> */}
            {/*     </MenuItem> */}
            {/*     <MenuItem value="Show All"> */}
            {/*       <em>Show All</em> */}
            {/*     </MenuItem> */}
            {/*   </Select> */}
            {/* </Box> */}
            <div style={{ height: 600, width: "100%" }}>
                <DataGrid
                    style={{ cursor: "pointer" }}
                    rows={filteredRows}
                    rowHeight={50}
                    initialState={{
                        columns: {
                            columnVisibilityModel: {
                                request_id: false,
                            },
                        },
                    }}
                    columns={[
                        {
                            field: "request_id",
                            headerName: "Request ID",
                            width: 110,
                            editable: false,
                        },
                        {
                            field: "acc_code",
                            headerName: "A/C No.",
                            width: 80,
                            editable: false,
                        },
                        {
                            field: "nqs",
                            headerName: "No Quibbles",
                            width: 120,
                            align: "right",
                            editable: false,
                            // renderCell: (params) => {
                            //   return updatedField(params.row.nqs, params.row.previous_email)
                            // },
                        },
                        {
                            field: "sales",
                            headerName: "Sales",
                            width: 120,
                            align: "right",
                            editable: false,
                            // renderCell: (params) => {
                            //   return updatedField(
                            //     params.row.first_name,
                            //     params.row.previous_first_name
                            //   )
                            // },
                        },
                        {
                            field: "percent",
                            headerName: "Percent",
                            width: 120,
                            editable: true,
                            align: "right",
                            renderCell: (params) => {
                                return <span style={ params.row.percent >= 0.5 ? {color: "red"}  : {color: ""} }>{params.row.percent.toFixed(2)}%</span>
                            },

                        },
                        // {
                        //     field: "available_qty",
                        //     headerName: "Available Qty",
                        //     width: 120,
                        //     editable: false,
                        //     align: "right",
                        //     renderCell: (params) => {
                        //         return <span style={ params.row.percent >= 0.5 ? {color: "red"}  : {color: ""} }>{}</span>
                        //     },
                        //
                        // },
                        {
                            field: "blacklisted",
                            headerName: "Enable No-Quibbles",
                            width: 800,
                            renderCell: (params) => {
                                const handleToggle = (event) => {
                                    const checked = !event.target.checked
                                    setRows((prev) =>
                                        prev.map((row) =>
                                            row.id === params.row.id
                                                ? { ...row, is_blacklisted: checked }
                                                : row
                                        )
                                    )

                                    axios
                                        .post(
                                            `${API_URL}/customer/set_blacklist?acc_code=${params.row.acc_code}&enabled=${checked}`,
                                            {},
                                            {
                                                headers: {
                                                    Authorization: `Bearer ${token}`,
                                                },
                                            }
                                        )
                                        .then(() => {
                                            // setSnackbarMessage(
                                            //     "Request has been rejected, no email will be sent"
                                            // )
                                            // setShowSnackbar(true)
                                            // reload()
                                        })
                                        .catch((err) => {
                                            alert(JSON.stringify(err))
                                        })

                                }


                                return (
                                    <>
                                        <Switch 
                                            checked={!params.row.is_blacklisted}
                                            onChange={handleToggle}
                                        />
                                    </>
                                )
                            },
                        },
                    ]}
                    getRowHeight={() => "auto"} // Adjust row height dynamically
                    sx={{
                        "& .MuiDataGrid-cell": {
                            whiteSpace: "normal", // Allow text wrapping
                            wordBreak: "break-word", // Break long words if needed
                            lineHeight: "1.5", // Adjust line height for readability
                        },
                    }}
                    pageSize={pageSize}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    rowsPerPageOptions={[5, 10, 25]}
                    pagination
                    disableRowSelectionOnClick
                    checkboxSelection={false}
                />
            </div>







            <Snackbar
                name="snackbar"
                open={showSnackbar}
                autoHideDuration={6000}
                onClose={() => setShowSnackbar(false)}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                sx={{
                    marginTop: "13vh",
                    border: "2px solid lightgray",
                    borderRadius: "5px",
                }}
            >
                <Alert
                    onClose={() => setShowSnackbar(false)}
                    severity="success"
                    sx={{ width: "100%" }}
                >
                    {snackbarMessage}
                </Alert>
            </Snackbar>





        </div>
    )
}
